export const routes = [
  { path: "/", label: "Ana sayfa", shortLabel: "Ana" },
  { path: "/kesfet", label: "Etkinlik keşfet", shortLabel: "Keşfet" },
  { path: "/etkinlik-olustur", label: "Etkinlik oluştur", shortLabel: "Oluştur" },
  { path: "/harita", label: "Harita", shortLabel: "Harita" },
  { path: "/profilim", label: "Profilim", shortLabel: "Profil" },
  { path: "/host", label: "Host profili", shortLabel: "Host" },
  { path: "/giris", label: "Giriş", shortLabel: "Giriş" },
];

export const heroMetrics = [
  { value: "1267", label: "İşlenmiş etkinlik fikri", tone: "green" },
  { value: "18", label: "Kategori ailesi", tone: "cyan" },
  { value: "Maps", label: "Mekân ve konum katmanı", tone: "purple" },
];

export const homeSections = [
  {
    icon: "EV",
    tone: "green",
    title: "Etkinlik fikrini hızlıca bul",
    description: "Kullanıcı etkinlik oluştururken başlığın orta veya son kelimesiyle katalog fikrini bulup seçebilir.",
  },
  {
    icon: "SQ",
    tone: "cyan",
    title: "Squad sistemiyle küçük gruplar",
    description: "Katılımcılar boş koltukları görür, güvenli şekilde uygun gruba katılır ve host akışı net kalır.",
  },
  {
    icon: "MP",
    tone: "purple",
    title: "Harita merkezli keşif",
    description: "Yakındaki etkinlikler, mekân seçimi ve adres çözümleme web deneyiminin temel katmanı olur.",
  },
];

export const featuredEvents = [
  {
    title: "Yapay zekâ ile görsel üretim workshop’u",
    category: "Technology & Innovation",
    meta: "Bugün 19:30 / Coworking",
    tone: "purple",
  },
  {
    title: "Marina Coffee Circle",
    category: "Community & Social",
    meta: "Yarın 11:30 / Marina",
    tone: "amber",
  },
  {
    title: "Sunset Board Games",
    category: "Gaming & Esports",
    meta: "Bugün 18:00 / Kaleiçi",
    tone: "cyan",
  },
  {
    title: "Konyaaltı Beach Run",
    category: "Sports & Fitness",
    meta: "Pazar 07:20 / Sahil",
    tone: "green",
  },
];

export const categoryGroups = [
  "Müzik",
  "Film & Medya",
  "Spor",
  "İş & Networking",
  "Kültür & Sanat",
  "Yeme & İçme",
  "Gaming",
  "Wellness",
  "Outdoor",
  "Teknoloji",
];

export const createEventSteps = [
  "Katalogda etkinlik ara",
  "Preset özelliklerini incele",
  "Tarih, saat ve kişi sayısını düzenle",
  "Mekânı haritadan seç",
  "Yayın ayarlarını tamamla",
];

export const hostSignals = [
  { value: "98%", label: "Güven skoru", tone: "green" },
  { value: "12", label: "Host streak", tone: "cyan" },
  { value: "Gold", label: "Seviye", tone: "amber" },
];

export const mapMarkers = [
  { label: "128", left: "22%", top: "34%", tone: "pink", title: "Neon Beach Meetup" },
  { label: "42", left: "58%", top: "42%", tone: "cyan", title: "Sunset Board Games" },
  { label: "24", left: "44%", top: "66%", tone: "amber", title: "Marina Coffee Circle" },
  { label: "35", left: "72%", top: "24%", tone: "green", title: "Beach Run" },
];

export const mapHotspots = [
  {
    id: "neon-beach",
    title: "Neon Beach Meetup",
    category: "Nightlife & Entertainment",
    label: "128",
    tone: "pink",
    toneColor: "#ff5bc8",
    coordinate: { lat: 36.88455, lng: 30.65752 },
  },
  {
    id: "sunset-board-games",
    title: "Sunset Board Games",
    category: "Gaming & Esports",
    label: "42",
    tone: "cyan",
    toneColor: "#28e8ff",
    coordinate: { lat: 36.88584, lng: 30.70388 },
  },
  {
    id: "marina-coffee-circle",
    title: "Marina Coffee Circle",
    category: "Community & Social",
    label: "24",
    tone: "amber",
    toneColor: "#ffd166",
    coordinate: { lat: 36.88356, lng: 30.70222 },
  },
  {
    id: "beach-run",
    title: "Konyaaltı Beach Run",
    category: "Sports & Fitness",
    label: "35",
    tone: "green",
    toneColor: "#5effc5",
    coordinate: { lat: 36.89113, lng: 30.71293 },
  },
];
